module.exports = __webpack_public_path__ + "img/social-messages-ua.7389ffc8.png";